require("core-js/modules/es6.regexp.split");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.sl = t());
}(this, function () {
  "use strict";

  return [{
    locale: "sl",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var r = String(e).split("."),
          o = r[0],
          a = !r[1],
          i = o.slice(-2);
      return t ? "other" : a && 1 == i ? "one" : a && 2 == i ? "two" : a && (3 == i || 4 == i) || !a ? "few" : "other";
    },
    fields: {
      year: {
        displayName: "leto",
        relative: {
          0: "letos",
          1: "naslednje leto",
          "-1": "lani"
        },
        relativeTime: {
          future: {
            one: "čez {0} leto",
            two: "čez {0} leti",
            few: "čez {0} leta",
            other: "čez {0} let"
          },
          past: {
            one: "pred {0} letom",
            two: "pred {0} letoma",
            few: "pred {0} leti",
            other: "pred {0} leti"
          }
        }
      },
      "year-short": {
        displayName: "leto",
        relative: {
          0: "letos",
          1: "naslednje leto",
          "-1": "lani"
        },
        relativeTime: {
          future: {
            one: "čez {0} leto",
            two: "čez {0} leti",
            few: "čez {0} leta",
            other: "čez {0} let"
          },
          past: {
            one: "pred {0} letom",
            two: "pred {0} letoma",
            few: "pred {0} leti",
            other: "pred {0} leti"
          }
        }
      },
      month: {
        displayName: "mesec",
        relative: {
          0: "ta mesec",
          1: "naslednji mesec",
          "-1": "prejšnji mesec"
        },
        relativeTime: {
          future: {
            one: "čez {0} mesec",
            two: "čez {0} meseca",
            few: "čez {0} mesece",
            other: "čez {0} mesecev"
          },
          past: {
            one: "pred {0} mesecem",
            two: "pred {0} mesecema",
            few: "pred {0} meseci",
            other: "pred {0} meseci"
          }
        }
      },
      "month-short": {
        displayName: "mes.",
        relative: {
          0: "ta mesec",
          1: "naslednji mesec",
          "-1": "prejšnji mesec"
        },
        relativeTime: {
          future: {
            one: "čez {0} mes.",
            two: "čez {0} mes.",
            few: "čez {0} mes.",
            other: "čez {0} mes."
          },
          past: {
            one: "pred {0} mes.",
            two: "pred {0} mes.",
            few: "pred {0} mes.",
            other: "pred {0} mes."
          }
        }
      },
      day: {
        displayName: "dan",
        relative: {
          0: "danes",
          1: "jutri",
          2: "pojutrišnjem",
          "-2": "predvčerajšnjim",
          "-1": "včeraj"
        },
        relativeTime: {
          future: {
            one: "čez {0} dan",
            two: "čez {0} dneva",
            few: "čez {0} dni",
            other: "čez {0} dni"
          },
          past: {
            one: "pred {0} dnevom",
            two: "pred {0} dnevoma",
            few: "pred {0} dnevi",
            other: "pred {0} dnevi"
          }
        }
      },
      "day-short": {
        displayName: "dan",
        relative: {
          0: "danes",
          1: "jutri",
          2: "pojutrišnjem",
          "-2": "predvčerajšnjim",
          "-1": "včeraj"
        },
        relativeTime: {
          future: {
            one: "čez {0} dan",
            two: "čez {0} dneva",
            few: "čez {0} dni",
            other: "čez {0} dni"
          },
          past: {
            one: "pred {0} dnevom",
            two: "pred {0} dnevoma",
            few: "pred {0} dnevi",
            other: "pred {0} dnevi"
          }
        }
      },
      hour: {
        displayName: "ura",
        relative: {
          0: "v tej uri"
        },
        relativeTime: {
          future: {
            one: "čez {0} uro",
            two: "čez {0} uri",
            few: "čez {0} ure",
            other: "čez {0} ur"
          },
          past: {
            one: "pred {0} uro",
            two: "pred {0} urama",
            few: "pred {0} urami",
            other: "pred {0} urami"
          }
        }
      },
      "hour-short": {
        displayName: "ura",
        relative: {
          0: "v tej uri"
        },
        relativeTime: {
          future: {
            one: "čez {0} uro",
            two: "čez {0} uri",
            few: "čez {0} ure",
            other: "čez {0} ur"
          },
          past: {
            one: "pred {0} uro",
            two: "pred {0} urama",
            few: "pred {0} urami",
            other: "pred {0} urami"
          }
        }
      },
      minute: {
        displayName: "minuta",
        relative: {
          0: "to minuto"
        },
        relativeTime: {
          future: {
            one: "čez {0} minuto",
            two: "čez {0} minuti",
            few: "čez {0} minute",
            other: "čez {0} minut"
          },
          past: {
            one: "pred {0} minuto",
            two: "pred {0} minutama",
            few: "pred {0} minutami",
            other: "pred {0} minutami"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "to minuto"
        },
        relativeTime: {
          future: {
            one: "čez {0} min.",
            two: "čez {0} min.",
            few: "čez {0} min.",
            other: "čez {0} min."
          },
          past: {
            one: "pred {0} min.",
            two: "pred {0} min.",
            few: "pred {0} min.",
            other: "pred {0} min."
          }
        }
      },
      second: {
        displayName: "sekunda",
        relative: {
          0: "zdaj"
        },
        relativeTime: {
          future: {
            one: "čez {0} sekundo",
            two: "čez {0} sekundi",
            few: "čez {0} sekunde",
            other: "čez {0} sekund"
          },
          past: {
            one: "pred {0} sekundo",
            two: "pred {0} sekundama",
            few: "pred {0} sekundami",
            other: "pred {0} sekundami"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "zdaj"
        },
        relativeTime: {
          future: {
            one: "čez {0} s",
            two: "čez {0} s",
            few: "čez {0} s",
            other: "čez {0} s"
          },
          past: {
            one: "pred {0} s",
            two: "pred {0} s",
            few: "pred {0} s",
            other: "pred {0} s"
          }
        }
      }
    }
  }];
});